export { default as useCacheProductSearches } from './useCacheProductSearches';
